// Maskotun anlık ifadesini (mood) öncelik sırasıyla hesaplar.
// success > error > covering (şifre odakta+görünür) > looking (bir alan odakta) > idle.
export function computeMood({ activeField, passwordVisible, submitStatus }) {
  if (submitStatus === 'success') return 'happy';
  if (submitStatus === 'error') return 'sad';
  if (activeField === 'password' && passwordVisible) return 'covering';
  if (activeField === 'email' || activeField === 'password') return 'looking';
  return 'idle';
}

// Yazılan değerin uzunluğunu pupillerin yatay kayması için [-1, 1] aralığına eşler.
// Boş → -1 (sola), ~yarı → 0 (orta), dolu → 1 (sağa).
export function valueToLookX(value, maxChars = 20) {
  const len = (value || '').length;
  const ratio = Math.min(len / maxChars, 1);
  return Math.round((ratio * 2 - 1) * 1000) / 1000;
}
